import axios from "axios";

export default async function common_function() {
  // let sessionUser = sessionStorage.getItem("user");
//   if (document.getElementById('room_code') !== null) { 
//     const response = await axios.get(process.env.VUE_APP_BASE_URL+"room/get_forms")   
// if(response.data.success==true){
//    const data = response.data.data;
//    let room_code = document.getElementById('room_code');
//      // Iterate over the post data and create list items
//      if(room_code !== null) {
//        data.forEach(post => {
//          const listItem = document.createElement('option');
//          listItem.textContent = post.room_code;
//          listItem.setAttribute('data-room_code_id', post._id)
//          listItem.setAttribute("data-room_code_name", post.room_number)
//          room_code.appendChild(listItem);
//        })
//      }
// }
// }
//   if (document.getElementById('amenities_type_code') !== null) { 
//     const response = await axios.get(process.env.VUE_APP_BASE_URL+"amenities_types/get_forms")   
// if(response.data.success==true){
//    const data = response.data.data;
//    let amenities_types_code = document.getElementById('amenities_type_code');
//      // Iterate over the post data and create list items
//      if(amenities_types_code !== null) {
//        data.forEach(post => {
//          const listItem = document.createElement('option');
//          listItem.textContent = post.amenities_types_code;
//          listItem.setAttribute('data-amenities_types_code_id', post._id)
//          amenities_types_code.appendChild(listItem);
//        })
//      }
// }
// }
//   if (document.getElementById('amenities_category_code') !== null) { 
//     const response = await axios.get(process.env.VUE_APP_BASE_URL+"amenities_category/get_forms")   
// if(response.data.success==true){
//    const data = response.data.data;
//    let amenities_category_code = document.getElementById('amenities_category_code');
//      // Iterate over the post data and create list items
//      if(amenities_category_code !== null) {
//        data.forEach(post => {
//          const listItem = document.createElement('option');
//          listItem.textContent = post.amenities_category_code;
//          listItem.setAttribute('data-amenities_category_code_id', post._id)
//          amenities_category_code.appendChild(listItem);
//        })
//      }
// }
// }
//   if (document.getElementById('level_of_care') !== null) { 
//     const response = await axios.get(process.env.VUE_APP_BASE_URL+"level_of_care_infrastructure/get_forms")   
// if(response.data.success==true){
//    const data = response.data.data;
//    let level_of_care_code = document.getElementById('level_of_care');
//      // Iterate over the post data and create list items
//      if(level_of_care_code !== null) {
//        data.forEach(post => {
//          const listItem = document.createElement('option');
//          listItem.textContent = post.level_of_care_code;
//          listItem.setAttribute('data-level_of_care_code_id', post._id)
//          level_of_care_code.appendChild(listItem);
//        })
//      }
// }
// }
  // if (document.getElementById("nursing_unit_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "nursing_unit/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let nursing_unit_code = document.getElementById("nursing_unit_code");
  //     // Iterate over the post data and create list items
  //     if (nursing_unit_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-nursing_code_id", post._id);
  //         // listItem.setAttribute(
  //         //   "data-area_building_name",
  //         //   post.area_building_name
  //         // );
  //         listItem.textContent = post.nursing_unit_code;
  //         nursing_unit_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("room_type_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "room-type/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let room_type_code = document.getElementById("room_type_code");
  //     // Iterate over the post data and create list items
  //     if (room_type_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-room_type_code_id", post._id);
  //         // listItem.setAttribute(
  //         //   "data-area_building_name",
  //         //   post.area_building_name
  //         // );
  //         listItem.textContent = post.room_type_code;
  //         room_type_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("workforce_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "worforce_management/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let workforce_code = document.getElementById("workforce_code");
  //     // Iterate over the post data and create list items
  //     if (workforce_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.workforce_code;
  //         listItem.setAttribute('data-workforce_modal_id', post._id)
  //         listItem.setAttribute('data-workforce_description_name', post.workforce_description)
  //         workforce_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_role_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_roles/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_role_code = document.getElementById("user_role_code");
  //     // Iterate over the post data and create list items
  //     if (user_role_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-user_role_id', post._id)
  //         listItem.textContent = post.user_role_code;
  //         user_role_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_sub_group_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_sub_group/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_sub_group_code = document.getElementById("user_sub_group_code");
  //     // Iterate over the post data and create list items
  //     if (user_sub_group_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-user_sub_group_id', post._id)
  //         listItem.textContent = post.user_sub_group_code;
  //         user_sub_group_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_group_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_group/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_group_code = document.getElementById("user_group_code");
  //     // Iterate over the post data and create list items
  //     if (user_group_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.user_group_code;
  //         listItem.setAttribute("data-user_group_modal_id", post._id);
  //         user_group_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }f
  // if (document.getElementById("user_category_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_category/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_category_code = document.getElementById("user_category_code");
  //     // Iterate over the post data and create list items
  //     if (user_category_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-user_category_id', post._id)
  //         listItem.textContent = post.user_category_code;
  //         user_category_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("team_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_team_workforce/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let team_code = document.getElementById("team_code");
  //     // Iterate over the post data and create list items
  //     if (team_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-team_id', post._id)
  //         listItem.textContent = post.team_code;
  //         team_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  
  // if (document.getElementById("operational_unit_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "operation_units/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let operational_unit_code = document.getElementById(
  //       "operational_unit_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (operational_unit_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-operational_unit_modal_id", post._id);
  //         if (post.primary_unit === true) {
  //           listItem.textContent = post.operational_unit_code + " (Primary)";
  //           operational_unit_code.appendChild(listItem);
  //         } else {
  //           listItem.textContent = post.operational_unit_code + " (Secondary)";
  //           operational_unit_code.appendChild(listItem);
  //         }
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_designation_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_designation/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_designation_code = document.getElementById(
  //       "user_designation_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (user_designation_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-user_designation_id', post._id)
  //         listItem.textContent = post.user_designation_code;
  //         user_designation_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_grade_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_grade/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_grade_code = document.getElementById("user_grade_code");
  //     // Iterate over the post data and create list items
  //     if (user_grade_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.user_grade_code;
  //         user_grade_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("user_employment_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "user_employment/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let user_employment_code = document.getElementById(
  //       "user_employment_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (user_employment_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.user_employment_code;
  //         user_employment_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  if (document.getElementById("user_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "user_management/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let user_code = document.getElementById("user_code");
      // Iterate over the post data and create list items
      if (user_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.setAttribute("data-user_code_modal_id", post._id);
          listItem.textContent = post.user_code;
          user_code.appendChild(listItem);
        });
      }
    }
  }
  if (document.getElementById("employee_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "employment_type/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let employee_code = document.getElementById("employee_code");
      // Iterate over the post data and create list items
      if (employee_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.employee_code;
          employee_code.appendChild(listItem);
        });
      }
    }
  }
  if (document.getElementById("company_shift_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "company_working_shifts/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let company_shift_code = document.getElementById("company_shift_code");
      // Iterate over the post data and create list items
      if (company_shift_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.company_shift_code ;
          listItem.setAttribute("data-company_shift_id",post._id)
          company_shift_code.appendChild(listItem);
        });
      }
    }
  }
  // if (document.getElementById("calender_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "company_calender/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let calender_code = document.getElementById("calender_code");
  //     // Iterate over the post data and create list items
  //     if (calender_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-calender_id', post._id)
  //         listItem.textContent = post.calender_code;
  //         calender_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  if (
    document.getElementById("license_code") !== null ||
    document.getElementById("license_name") !== null
  ) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "liscense_details/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let license_code = document.getElementById("license_code");
      // Iterate over the post data and create list items
      if (license_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.license_code;
          license_code.appendChild(listItem);
        });
      }
      let license_name = document.getElementById("license_name");
      // Iterate over the post data and create list items
      if (license_name !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.license_name;
          license_name.appendChild(listItem);
        });
      }
    }
  }
  // if (document.getElementById("skill_set_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "skill_set/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let skill_set_code = document.getElementById("skill_set_code");
  //     // Iterate over the post data and create list items
  //     if (skill_set_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute('data-skill_set_id', post._id)
  //         listItem.textContent = post.skill_set_code;
  //         skill_set_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  if (document.getElementById("training_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "training/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let training_code = document.getElementById("training_code");
      // Iterate over the post data and create list items
      if (training_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.training_code;
          training_code.appendChild(listItem);
        });
      }
    }
  }
  if (document.getElementById("scheduling_reason_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "maintaining_scheduling_reason/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let scheduling_reason_code = document.getElementById(
        "scheduling_reason_code"
      );
      // Iterate over the post data and create list items
      if (scheduling_reason_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.scheduling_reason_code;
          scheduling_reason_code.appendChild(listItem);
        });
      }
    }
  }
  if (document.getElementById("employee_grade_code") !== null) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "employee_grade/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let employee_grade_code = document.getElementById("employee_grade_code");
      // Iterate over the post data and create list items
      if (employee_grade_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.employee_grade_code;
          employee_grade_code.appendChild(listItem);
        });
      }
    }
  }
  
  // if (document.getElementById("sub_department_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "sub_department_communication/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let sub_department_code = document.getElementById("sub_department_code");
  //     // Iterate over the post data and create list items
  //     if (sub_department_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.sub_department_code;
  //         sub_department_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("section_department_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "department_communication/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let section_department_code = document.getElementById(
  //       "section_department_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (section_department_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.section_department_code;
  //         listItem.setAttribute("data-department-name", post.section_department_name)
  //         section_department_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("location_floor_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "building_map/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let location_floor_code = document.getElementById("location_floor_code");
  //     // Iterate over the post data and create list items
  //     if (location_floor_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-location_floor_code_id", post._id);
  //         listItem.setAttribute(
  //           "data-location_floor_name",
  //           post.location_floor_room_name
  //         );
  //         listItem.textContent = post.location_floor_code;
  //         location_floor_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }
  // if (document.getElementById("area_building_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "building_structure/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let area_building_code = document.getElementById("area_building_code");
  //     // Iterate over the post data and create list items
  //     if (area_building_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-area_building_code_id", post._id);
  //         listItem.setAttribute(
  //           "data-area_building_name",
  //           post.area_building_name
  //         );
  //         listItem.textContent = post.area_building_code;
  //         area_building_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  if (
    document.getElementById("industry_code") !== null ||
    document.getElementById("industry_name") !== null
  ) {
    const response = await axios.get(
      process.env.VUE_APP_BASE_URL + "industry/get_forms"
    );
    if (response.data.success == true) {
      const data = response.data.data;
      let industry_code = document.getElementById("industry_code");
      // Iterate over the post data and create list items
      if (industry_code !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.industry_code;
          industry_code.appendChild(listItem);
        });
      }
      let industry_name = document.getElementById("industry_name");
      // Iterate over the post data and create list items
      if (industry_name !== null) {
        data.forEach((post) => {
          const listItem = document.createElement("option");
          listItem.textContent = post.industry_name;
          industry_name.appendChild(listItem);
        });
      }
    }
  }
  // if (
  //   document.getElementById("company_codes") !== null ||
  //   document.getElementById("company_name") !== null
  // ) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "company_creation/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let company_codes = document.getElementById("company_codes");
  //     // Iterate over the post data and create list items
  //     if (company_codes !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.company_codes;
  //         //new_codes--------------
  //         listItem.setAttribute("data-company_codes_id", post._id);
  //         listItem.setAttribute("data-company_name", post.company_name)
  //         company_codes.appendChild(listItem);
  //       });
  //     }
  //     let company_name = document.getElementById("company_name");
  //     // Iterate over the post data and create list items
  //     if (company_name !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.company_name;
  //         company_name.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  // if (document.getElementById("operational_unit_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "operation_units/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let operational_unit_code = document.getElementById(
  //       "operational_unit_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (operational_unit_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.setAttribute("data-operational_unit_id", post._id);
  //         listItem.setAttribute("data-operational_unit_name", post.branch_name);
  //         if (post.primary_unit === true) {
  //           listItem.textContent = post.operational_unit_code + " (Primary)";
  //           operational_unit_code.appendChild(listItem);
  //         } else {
  //           listItem.textContent = post.operational_unit_code + " (Secondary)";
  //           operational_unit_code.appendChild(listItem);
  //         }
  //       });
  //     }
  //   }
  // }


  //***********To Remove************* */

  // if (document.getElementById("material_category_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "material_category/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let material_category_code = document.getElementById(
  //       "material_category_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (material_category_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.material_category_code;
  //         listItem.setAttribute("data-material_category_code_id", post._id);
  //         material_category_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  // if (document.getElementById("material_type_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "material_type/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let material_type_code = document.getElementById("material_type_code");
  //     // Iterate over the post data and create list items
  //     if (material_type_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  
  //         listItem.textContent = post.material_type_code;
  //         listItem.setAttribute("data-material_type_code_id", post._id);
  //         material_type_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

//   if (document.getElementById("material_group_code") !== null) {
//   const response = await axios.get(
//     process.env.VUE_APP_BASE_URL + "material_group/get_forms"
//   );
//   console.log(response.data, "response data-->")
//   if (response.data.success) {
//     const data = response.data.data;
//     console.log("data",data)
//     let material_group_code = document.getElementById("material_group_code");
//     // Iterate over the post data and create list items
//     if (material_group_code !== null) {
//       data.forEach((post) => {
//         const listItem = document.createElement("option");
//         console.log("listitem",post)
//         listItem.textContent = post.material_group_code;
//         listItem.setAttribute("data-material_group_id", post._id);
//         material_group_code.appendChild(listItem);
//       });
//     }
//   }
// }
  
  // if (document.getElementById("material_sub_group_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "material_sub_group/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let material_sub_group_code = document.getElementById(
  //       "material_sub_group_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (material_sub_group_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.material_sub_group_code;
  //         listItem.setAttribute("data-material_sub_group_id", post._id);
  //         material_sub_group_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  // if (document.getElementById("item_sub_category_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "item_sub_category/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let item_sub_category_code = document.getElementById(
  //       "item_sub_category_code"
  //     );
  //     // Iterate over the post data and create list items
  //     if (item_sub_category_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.item_sub_category_code;
  //         listItem.setAttribute("data-item_sub_category_id", post._id);

  //         item_sub_category_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  // if (document.getElementById("item_category_code") !== null) {
  //   const response = await axios.get(
  //     process.env.VUE_APP_BASE_URL + "item_category/get_forms"
  //   );
  //   if (response.data.success == true) {
  //     const data = response.data.data;
  //     let item_category_code = document.getElementById("item_category_code");
  //     // Iterate over the post data and create list items
  //     if (item_category_code !== null) {
  //       data.forEach((post) => {
  //         const listItem = document.createElement("option");
  //         listItem.textContent = post.item_category_code;
  //         listItem.setAttribute("data-item_category_id", post._id);
  //         item_category_code.appendChild(listItem);
  //       });
  //     }
  //   }
  // }

  
// if (document.getElementById("brand_code") !== null) {
//   const response = await axios.get(
//     process.env.VUE_APP_BASE_URL + "brand/get_forms"
//   );
//   if (response.data.success == true) {
//     const data = response.data.data;
//     let brand_code = document.getElementById("brand_code");
//     // Iterate over the post data and create list items
//     if (brand_code !== null) {
//       data.forEach((post) => {
//         const listItem = document.createElement("option");
//         listItem.textContent = post.brand_code;
//         listItem.setAttribute("data-brand_code_id", post._id);
//         brand_code.appendChild(listItem);
//       });
//     }
//   }
// }

// if (document.getElementById("item_class_code") !== null) {
//   const response = await axios.get(
//     process.env.VUE_APP_BASE_URL + "item_class/get_forms"
//   );
//   if (response.data.success == true) {
//     const data = response.data.data;
//     let item_class_code = document.getElementById("item_class_code");
//     // Iterate over the post data and create list items
//     if (item_class_code !== null) {
//       data.forEach((post) => {
//         const listItem = document.createElement("option");
//         listItem.textContent = post.item_class_code;
//         listItem.setAttribute("data-item_class_code_id", post._id);
//         item_class_code.appendChild(listItem);
//       });
//     }
//   }
// }

// if (
//   document.getElementById("item_code") !== null ||
//   document.getElementById("item_trade_code") !== null ||
//   document.getElementById("item_secure_code") !== null
// ) {
//   const response = await axios.get(
//     process.env.VUE_APP_BASE_URL + "item/get_forms"
//   );
//   if (response.data.success == true) {
//     const data = response.data.data;
//     let item_code = document.getElementById("item_code");
//     // Iterate over the post data and create list items
//     if (item_code !== null) {
//       data.forEach((post) => {
//         const listItem = document.createElement("option");
//         listItem.textContent = post.item_code;

//         listItem.setAttribute("data-item_code_id", post._id);
//         listItem.setAttribute("data-item_name", post.item_name_long);
//         item_code.appendChild(listItem);
//       });
//     }
//   }
//}
}
